import PropTypes from 'prop-types';
import React from 'react';
import SweetAlert from 'sweetalert-react';

const ERROR_TEXT = [
  'You have an appointment in less than professional\'s advance cancelation time. ',
  'Please call the shop for further assistance.',
].join('');

const UnableToRescheduleModal = ({ isOpen, closeModal }) => (
  <SweetAlert
    show={isOpen}
    title="Unable to reschedule appointment"
    text={ERROR_TEXT}
    type="error"
    onConfirm={closeModal}
    onEscapeKey={closeModal}
  />
);
UnableToRescheduleModal.propTypes = {
  isOpen: PropTypes.bool,
  closeModal: PropTypes.func.isRequired,
};
UnableToRescheduleModal.defaultProps = {
  isOpen: false,
};
export default UnableToRescheduleModal;



// WEBPACK FOOTER //
// ./src/app/reservation/components/UnableToRescheduleModal.jsx